import {Component, OnInit} from '@angular/core';
import { GoogleMap } from "@angular/google-maps";
import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";
import {EventsManager} from "../../../events/events.manager";
import {GeocoderResponse} from "../../../models/geocoder.response";
import {StateModel} from "../../../models/state.model";
import { FormsModule } from '@angular/forms';
import { NgIf, NgFor } from '@angular/common';

@Component({
    selector: 'app-state-selection',
    templateUrl: './state-selection.component.html',
    styleUrl: './state-selection.component.scss',
    standalone: true,
    imports: [NgIf, FormsModule, NgFor]
})
export class StateSelectionComponent implements OnInit {
  timeMessage: string = "";
  state: StateModel = {name:'',value:'',abbr:''};
  stateName:string = 'none';
  allowSave:boolean = false;
  stateNotAllowed:boolean = false;
  chooseState:boolean = false;

  point: google.maps.LatLngLiteral = {
    lat: 0,
    lng: 0,
  };
  position:any = '';

  constructor(public modal: NgbActiveModal,public manager: EventsManager,) {
  }

  ngOnInit() {
    this.geolocate();
    this.getTime();
  }

  geolocate() {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition( (position) => {
        this.position = position;
        this.point.lat = position.coords.latitude;
        this.point.lng = position.coords.longitude;
        this.manager.isLocationOff = false;
        this.allowSave = true;
       this.codeLatLng(this.point);
      }, (error) => {
        this.getStateError();
      });
    } else {
      this.manager.isLocationConfirmPage = false;
      this.manager.isLocationOff = true;
    }
  }

  getStateError() {
      this.manager.isLocationConfirmPage = false;
      this.manager.isLocationOff = true;
      this.allowSave = false;
  }

  setChooseState(){
    this.chooseState = true;
  }

  codeLatLng(location: google.maps.LatLngLiteral): Promise<GeocoderResponse> {
    let geocoder = new google.maps.Geocoder();
    return new Promise((resolve, reject) => {
      geocoder.geocode({ 'location': location }, (results, status) => {
        const response = new GeocoderResponse(status, results);
        if (status == google.maps.GeocoderStatus.OK) {
          if (!(results) || results[1]) {
            results?.forEach((addy) => {
              if(addy.address_components[0].types[0] == 'administrative_area_level_1'){
                this.state.name = addy.address_components[0].long_name;
                this.state.value = addy.address_components[0].long_name;
                this.state.abbr = addy.address_components[0].short_name;
                this.setState({
                  target: {
                    value: this.state.abbr
                  }
                })
              }
            })
          }
        }
        resolve(response);
      });
    });
  }

  getTime() {
    var today = new Date();
    var curHr = today.getHours();

    if (curHr < 12) {
      this.timeMessage = 'Good Morning';
    } else if (curHr < 18) {
      this.timeMessage = 'Good Afternoon';
    } else {
      this.timeMessage = 'Good Evening';
    }
  }

  setState(event:any){
    if(this.manager.isStateAllowed(event.target.value)){
      this.stateName = event.target.value;
      this.stateNotAllowed = false;
      this.allowSave = true;
      this.state = this.manager.lookUpState(event.target.value);
    } else {
      this.allowSave = false;
      this.stateNotAllowed = true;
      this.state = this.manager.lookUpState(event.target.value);
    }

  }

  dismissState(){
    this.setChooseState();
    this.stateName = 'none';
  }

  confirmState(){
    if(this.manager.isLocationOff && this.stateName !== 'none'){
      this.state = this.manager.lookUpState(this.stateName)
    }
    if(this.state.name !== ''){
      sessionStorage['state'] = JSON.stringify(this.state);
      this.manager.getPlanOptions.emit();
      this.modal.close()
    }

  }
}
